module.exports = __webpack_public_path__ + "img/CoinsPaid_white.467b51ec.svg";